export default __webpack_public_path__ + "static/media/1 (7).9730f4ee.jpg";